<template>
  <div v-loading="treeLoading" class="planApprovalPoints" element-loading-text="获取数据中">
    <div class="planApprovalPointsLeft">
      <div class="top">
        <p>
          审图要点目录
        </p>
        <i class="el-icon-circle-plus-outline" @click="addPoint"></i>
      </div>
      <div class="pointTree">
        <el-tree ref="tree" node-key="id" :data="templateArr" :props="defaultProps" :expand-on-click-node="true"
          highlight-current @node-click="clickNode">
          <template #default="{ node, data }">
            <span class="tree-node">
              <span :id="node.id" class="el-tree-node__label" :title="node.label">
                <i v-if="data.pid!=0" class="el-icon-ziji"></i>
                <span v-if="data.pid==0" style="font-weight:700;letter-spacing: 1px;">{{ node.label }}</span>
                <span v-else>{{ node.label }}</span>
              </span>
              <el-dropdown v-if="Node.id === node.id" placement="bottom-start" @command="handleCommand">
                <span class="el-dropdown-link" style="cursor: pointer">
                  <i class="el-icon-more"></i>
                </span>
                <el-dropdown-menu slot="dropdown" style="margin: 0px">
                  <el-dropdown-item command="update">编辑</el-dropdown-item>
                  <el-dropdown-item command="delete">删除</el-dropdown-item>
                  <el-dropdown-item command="moveUp">上移</el-dropdown-item>
                  <el-dropdown-item command="moveDown">下移</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </span>
          </template>
        </el-tree>
      </div>
    </div>
    <div class="planApprovalPointsRight">
      <div class="header">
        <el-form ref="form" label-width="0" size="small">
          <el-row :gutter="20">
            <el-col :span="19">
              <el-form-item>
                <el-button type="primary" icon="el-icon-plus" size="small" @click="addTemplate('current')">
                  添加
                </el-button>
                <el-button type="primary" plain size="small" @click="FieldOrder(1)">
                  上移
                </el-button>
                <el-button type="primary" plain size="small" @click="FieldOrder(2)">
                  下移
                </el-button>
                <el-button type="primary" plain size="small" @click="FieldOrder(3)">
                  升级
                </el-button>
                <el-button type="primary" plain size="small" @click="FieldOrder(4)">
                  降级
                </el-button>
                <el-button type="primary" plain size="small" @click="refresh">
                  刷新
                </el-button>
                <el-button type="danger" plain size="small" @click="deleteTemp">
                  批量删除
                </el-button>
                <el-button type="primary" plain size="small" @click="ImportTemp">
                  导入
                </el-button>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-input v-model="input" size="small" placeholder="请输入要点名称">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-table ref="multipleTable" :data="tableData1" border height="100%"
        row-key="id" highlight-current-row :tree-props="{ children: 'list', hasChildren: 'hasChildren' }"
        :expand-row-keys="expandRow" class="templateTable treeTab" @selection-change="handleSelectionChange">
        <template slot="empty">
          <img :src="zanwu" alt="" />
          <p style="font-size: 16px; color: #000; margin-top: 36px">
            暂无数据
          </p>
        </template>
        <el-table-column type="selection" align="center"></el-table-column>
        <el-table-column prop="cnName" label="要点名称">
          <template #default="{ row }">
            <el-link type="primary" @click="tableEdit(row)">
              <span class="tabLinkSpan" :title="row.cnName">{{ row.cnName }}</span>
            </el-link>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220">
          <template #default="{ row }">
            <div>
              <span class="edit" @click="tableEdit(row)">编辑</span>
              <span class="del" @click="tableDelete(row)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog v-dialogDrag :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="addPointOpen"
      :title="PointTitle" width="485px" top="25vh">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="ruleForm"
        label-position="top" size="small">
        <el-form-item label="请输入审图目录名称" prop="addVersionName">
          <el-input ref="addVersionName" v-model="ruleForm.addVersionName" type="textarea" placeholder="请输入审图目录名称" maxlength="40"
            show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="上级目录">
          <select-tree :key="Skey" ref="selectTree" style="width:100%" :props="props" :options="treeData"
            :value="valueId" :clearable="isClearable" :accordion="isAccordion" size="small" @getValue="getValue($event)">
          </select-tree>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addPointOpen = false">取 消</el-button>
        <el-button type="primary" size="small" @click="addPointDetermine">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog v-dialogDrag :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="addPointCatalogueOpen" :title="PointCatalogueTitle" width="485px" top="25vh">
      <el-form ref="PointCatalogueRuleForm" :model="rulePointCatalogueForm" :rules="PointCataloguerules"
        label-width="100px" class="ruleForm" label-position="top" size="small">
        <el-form-item label="请输入审图要点" prop="addVersionName">
          <el-input ref="addVersionName" v-model="rulePointCatalogueForm.addVersionName" type="textarea" placeholder="请输入审图要点"
            maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="上级审图要点">
          <select-tree ref="selectTree" style="width:100%" :props="props" :options="PointCatalogueTreeData"
            :value="PointCatalogueValueId" :clearable="isClearable" :accordion="isAccordion"
            size="small" @getValue="getValue($event)">
          </select-tree>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addPointCatalogueOpen = false">取 消</el-button>
        <el-button type="primary" size="small" @click="addPointCatalogueDetermine">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 弹框——导入 -->
    <el-dialog v-dialogDrag :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="excelOpen"
      title="导入" width="485px" top="28vh" custom-class="pointSetExcel">
      <div v-if="!fileList.length" class="downStyle">
        <p>请下载导入模板，按格式修改后导入</p>
        <el-button size="small" type="primary" @click="down">
          模板下载
        </el-button>
      </div>
      <div v-if="!fileList.length" class="uploadStyle">
        <div style="text-align: center;margin-top: 15px;margin-bottom: 15px;">
          <el-upload drag action="/" :before-upload="dataprogress1" :show-file-list="false" :http-request="httpRequest">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖拽至此区域，或<em>点击上传</em>
              <p style="color:var(--info-color)9;font-size:14px;margin-top:5px">仅支持xls、xlsx格式，文件大小不超过5M</p>
            </div>
          </el-upload>
        </div>
      </div>
      <div v-if="fileList.length" style="margin: 15px 0" class="uploadListStyle">
        <div class="box">
          <img :src="xlssrc" alt="" style="vertical-align: text-bottom;">
          <p style="margin-top:10px"><span>{{ fileList[0].name }}</span></p>
        </div>
        <div style="text-align:center;margin-top:20px">
          <el-button size="small" type="primary" plain :loading="disabledone2" @click="newuplode">
            重新上传
          </el-button>
          <el-button size="small" type="primary" :loading="disabledone2" @click="suredaoru">
            确认导入
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pointsService from "@/CommonDP/service/planApprovalPoints-service";
import { downloadSysReviewPoint } from "@/CommonDP/utils";
import SelectTree from "@/CommonDP/components/selectTree";
import { mapState } from "vuex";
export default {
  name: "PlanApprovalPoints",
  components: { SelectTree },
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      addPointOpen: false,
      PointTitle: "新增审图目录",
      ruleForm: {
        addVersionName: ""
      },
      rules: {
        addVersionName: [{ required: true, message: "请输入审图目录名称", trigger: "blur" }]
      },
      templateArr: [],
      defaultProps: { children: "list", label: "cnName", isLeaf: "leaf" },
      treeLoading: false,
      Node: {},
      templateTable: [],
      tableRechristenCommitName: "",
      // 上级审图要点
      treeData: [],
      isClearable: true,
      valueId: "",
      PointCatalogueValueId: "",
      props: {
        value: "id",
        label: "cnName",
        children: "list"
      },
      isAccordion: true,
      input: "",
      addPointCatalogueOpen: false,
      PointCatalogueTitle: "添加审图要点",
      rulePointCatalogueForm: {
        addVersionName: ""
      },
      PointCataloguerules: {
        addVersionName: [
          { required: true, message: "请输入审图要点", trigger: "blur" },
          { min: 0, max: 200, message: "审图要点长度在 0 到 200 个字符", trigger: "blur" }
        ]
      },
      PointCatalogueTreeData: [],
      selectionArr: [],
      excelOpen: false,
      fileList: [],
      xlssrc: require("@/CommonDP/assets/addpersonInfo/图表.png"),
      disabledone2: false, // 正在调用上传文件的接口
      tabRow: {},
      Skey: 0,
      expandRow: []
    };
  },
  async mounted() {
    this._initTempClass();
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    tableData1() {
      var searchValue = this.input;
      if (searchValue) {
        const treeData = this.templateTable;
        const handleTreeData = this.handleTreeData(treeData, searchValue);
        this.setExpandRow(handleTreeData);
        this.expandRow = this.expandRow.join(",").split(",");
        return handleTreeData;
      }
      return this.templateTable;
    }
  },
  created() {},
  methods: {
    //  树形表格过滤
    handleTreeData(treeData, searchValue) {
      if (!treeData || treeData.length === 0) {
        return [];
      }
      const array = [];
      for (let i = 0; i < treeData.length; i += 1) {
        let match = false;
        for (const pro in treeData[i]) {
          if (pro == "cnName") {
            if (typeof treeData[i][pro] === "string") {
              match |= treeData[i][pro].includes(searchValue);
              if (match) break;
            }
          }
        }
        if (this.handleTreeData(treeData[i].list, searchValue).length > 0 || match) {
          array.push({
            ...treeData[i],
            list: this.handleTreeData(treeData[i].list, searchValue)
          });
        }
      }
      return array;
    },
    // 将过滤好的树形数据展开
    setExpandRow(handleTreeData) {
      if (handleTreeData.length) {
        for (const i of handleTreeData) {
          this.expandRow.push(i.id);
          if (i.list.length) {
            this.setExpandRow(i.list);
          }
        }
      }
    },
    // 树级选择器
    getValue(value) {
      if (this.addPointOpen) {
        this.valueId = value.valueId;
      } else {
        this.PointCatalogueValueId = value.valueId;
      }
    },
    // 新增审图目录open
    addPoint() {
      this.addPointOpen = true;
      this.PointTitle = "新增审图目录";
      this.treeData = this.templateArr;
      this.$nextTick(() => {
        this.$refs.addVersionName.focus();
        this.$refs.ruleForm.resetFields();
        this.ruleForm.addVersionName = "";
        this.valueId = "";
        this.$refs.selectTree.valueTitle = "";
      });
    },
    // 审图目录名称确定添加
    addPointDetermine() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          if (this.PointTitle == "新增审图目录") {
            const params = {
              dicCode: this.enterpriseId,
              cnName: this.ruleForm.addVersionName,
              pid: this.valueId ? this.valueId : "0"
            };
            await pointsService.addDicMessage(params);
            this.$message.success("添加成功");
          } else {
            const params = {
              id: this.Node.data.id,
              cnName: this.ruleForm.addVersionName,
              pid: this.valueId ? this.valueId : "0"
            };
            await pointsService.updateTempClass(params);
            this.$message.success("修改成功");
          }
          this.addPointOpen = false;
          this._initTempClass();
        } else {
          return false;
        }
      });
    },
    // 初始化目录树
    async _initTempClass() {
      this.treeLoading = true;
      const result = await pointsService.queryTemplate(this.enterpriseId, "", "0");
      this.treeLoading = false;
      if (result.result == "0") {
        this.templateArr = result.data;
      }
    },
    // 点击目录树
    async clickNode(data, node) {
      this.Node = node;
      this.templateTable = [];
      const result = await pointsService.queryTemplate(this.Node.data.id, this.input, "0");
      this.templateTable = result.data;
    },
    // 三个点功能修改、删除、添加子目录
    async handleCommand(command) {
      switch (command) {
        case "delete":
          this.$confirm("确定删除吗？", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            customClass: "el-message-box"
          })
            .then(async () => {
              const ids = [this.Node.data.id];
              const result = await pointsService.deleteTempClass(ids);
              if (result.result === "0") {
                this.$refs.tree.remove(this.Node);
                this.$message.success("删除成功");
                this.templateTable = [];
                this.selectionArr = [];
                this.tabRow = {};
                this.Node = {};
              } else {
                this.$message.error("删除失败,请重新删除");
              }
            })
            .catch(() => {});
          break;
        case "update":
          this.editFn();
          break;
        case "moveUp":
          this.leftTreeMove(1);
          break;
        case "moveDown":
          this.leftTreeMove(2);
          break;
      }
    },
    arrangeData(nodes) {
      if (this.Node.data.pid == "0") {
        const newArr = nodes.filter((item) => item.id != this.Node.data.id);
        return newArr;
      } else {
        nodes.forEach((v) => {
          if (v.id == this.Node.data.pid) {
            v.list = [];
          } else {
            this.arrangeData(v.list);
          }
        });
        return nodes;
      }
    },
    // 勾选复选框
    handleSelectionChange(selections) {
      this.selectionArr = selections;
    },
    // 编辑审图要点
    async tableEdit(row) {
      this.tabRow = row;
      this.PointCatalogueTitle = "编辑审图要点";
      const result = await pointsService.queryTemplate(this.Node.data.id, this.input, "0");
      this.PointCatalogueTreeData = this.arrangeDataTwo(result.data, row);
      this.PointCatalogueValueId = row.pid == "0" ? "" : row.pid;
      this.addPointCatalogueOpen = true;
      this.$nextTick(() => {
        this.$refs.PointCatalogueRuleForm.resetFields();
        this.rulePointCatalogueForm.addVersionName = row.cnName;
      });
    },
    // 整理 删除不要的数据
    arrangeDataTwo(nodes, row) {
      if (row.pid == "0") {
        const newArr = nodes.filter((item) => item.id != row.id);
        return newArr;
      } else {
        nodes.forEach((v) => {
          if (v.id == row.pid) {
            v.list = [];
          } else {
            this.arrangeDataTwo(v.list, row);
          }
        });
        return nodes;
      }
    },
    // 单个删除审图要点
    tableDelete(row) {
      const ids = [row.id];
      this.$confirm("确定删除所选审图要点？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "el-message-box"
      })
        .then(async () => {
          await pointsService.deleteTempClass(ids);
          this.$message.success("删除成功");
          this.tabRow = {};
          this.refresh();
        })
        .catch(() => {});
    },
    // 批量删除审图要点
    deleteTemp() {
      if (this.selectionArr.length === 0) {
        return this.$message.warning("选择要点后进行删除");
      }
      this.$confirm("确定删除吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "el-message-box"
      })
        .then(async () => {
          const ids = this.selectionArr.map((item) => item.id);
          await pointsService.deleteTempClass(ids);
          this.$message.success("删除成功");
          this.tabRow = {};
          this.refresh();
        })
        .catch();
    },
    // 导入open
    ImportTemp() {
      if (this.Node.data) {
        this.excelOpen = true;
        this.fileList = [];
      } else {
        this.$message.warning("请先选择审图要点目录");
      }
    },
    // 上移下移 升序 降序
    async FieldOrder(order) {
      if (this.selectionArr.length > 1 || this.selectionArr.length === 0) {
        let messageWarning;
        order === 1 || order == 2 ? (messageWarning = "请勾选一项移动") : order == 3 ? (messageWarning = "请勾选一项升级") : (messageWarning = "请勾选一项降级");
        return this.$message.warning(`${messageWarning}`);
      }
      if (order == 1 || order == 2) {
        await pointsService.moveTempLeft(this.selectionArr[0].id, order);
        this.refresh();
        this.$message.success("移动成功");
      } else {
        let orderS;
        order === 3 ? (orderS = 0) : (orderS = 1);
        await pointsService.upOrDownTempLeft(this.selectionArr[0].id, orderS);
        this.refresh();
        let messageSuccess;
        order == 3 ? (messageSuccess = "升级成功") : (messageSuccess = "降级成功");
        this.$message.success(`${messageSuccess}`);
      }
    },
    // 添加审图要点
    addTemplate() {
      if (this.Node.data) {
        this.addPointCatalogueOpen = true;
        this.PointCatalogueTitle = "添加审图要点";
        this.PointCatalogueTreeData = this.templateTable;
        this.$nextTick(() => {
          this.$refs.addVersionName.focus();
          this.$refs.PointCatalogueRuleForm.resetFields();
          this.rulePointCatalogueForm.addVersionName = "";
          this.PointCatalogueValueId = "";
          this.$refs.selectTree.valueTitle = "";
        });
      } else {
        this.$message.warning("请先选择审图要点目录");
      }
    },
    // 审图要点目录上下移
    async leftTreeMove(order) {
      try {
        await pointsService.moveTempLeft(this.Node.data.id, order);
        this._initTempClass();
        this.$message.success("移动成功");
      } catch (e) {}
    },
    // 审图要点确定按钮
    addPointCatalogueDetermine() {
      this.$refs.PointCatalogueRuleForm.validate(async (valid) => {
        if (valid) {
          if (this.PointCatalogueTitle == "添加审图要点") {
            const params = {
              cnName: this.rulePointCatalogueForm.addVersionName,
              dicCode: this.Node.data.id,
              pid: this.PointCatalogueValueId ? this.PointCatalogueValueId : "0"
            };
            await pointsService.addDicMessage(params);
            this.$message.success("添加成功");
          } else {
            const params = {
              id: this.tabRow.id,
              cnName: this.rulePointCatalogueForm.addVersionName,
              pid: this.PointCatalogueValueId ? this.PointCatalogueValueId : "0"
            };
            await pointsService.updateTempClass(params);
            this.$message.success("修改成功");
          }
          this.addPointCatalogueOpen = false;
          this.refresh();
        } else {
          return false;
        }
      });
    },
    // 刷新
    async refresh() {
      this.templateTable = [];
      if (!this.Node || !this.Node.data || !this.Node.id) return;
      this.treeLoading = true;
      const result = await pointsService.queryTemplate(this.Node.data.id, this.input, "0");
      this.templateTable = result.data;
      this.treeLoading = false;
    },
    // 上传1
    dataprogress1(file) {
      const tt = file.name;
      const ttt = tt.split(".");
      const ttl = ttt.length;
      const isXLSX = ttt[ttl - 1] === "xlsx";
      const isXLS = ttt[ttl - 1] === "xls";
      const isPG = isXLSX || isXLS;
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isPG) {
        this.$message({
          showClose: true,
          message: "上传文件只能是 .xls .xlsx 格式!",
          type: "warning"
        });
      } else if (!isLt2M) {
        this.$message({
          showClose: true,
          message: "上传文件大小不能超过 5M!",
          type: "warning"
        });
      }
      return isPG && isLt2M;
    },
    // 上传2
    async httpRequest({ file }) {
      this.fileList.push(file);
    },
    // 重新上传
    newuplode() {
      this.disabledone2 = false;
      this.fileList = [];
    },
    // 确认导入
    async suredaoru() {
      this.disabledone2 = true;
      const data = new FormData();
      data.append("file", this.fileList[0]);
      data.append("dicCode", this.Node.data.id);
      try {
        await pointsService.sysReviewPointImport(data);
        this.$message.success("导入Excel成功");
        this.refresh();
        this.excelOpen = false;
        this.disabledone2 = false;
      } catch (error) {
        this.disabledone2 = false;
      }
    },
    // 下载模板
    down() {
      const downzipurl = downloadSysReviewPoint();
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.style.height = 0;
      iframe.src = downzipurl;
      document.body.appendChild(iframe);
      setTimeout(() => {
        iframe.remove();
      }, 5 * 60 * 1000);
    },
    async editFn() {
      this.PointTitle = "编辑审图目录";
      this.ruleForm.addVersionName = this.Node.data.cnName;
      const result = await pointsService.queryTemplate(this.enterpriseId, "", "0");
      this.treeData = this.arrangeData(result.data);
      this.valueId = this.Node.data.pid == "0" ? "" : this.Node.data.pid;
      this.addPointOpen = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.planApprovalPoints {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  position: relative;
  min-width: 1080px;
  .planApprovalPointsLeft {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 227px;
    background: #fff;
    overflow-y: auto;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    .top {
      padding: var(--middle-space) var(--big-space);
      border-bottom: 1px solid#E5E8F1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      p {
        font-size: 16px;
        font-weight: 700;
        color: var(--key-color);
      }
      i {
        font-size: 18px;
        color: var(--theme-color);
      }
    }
    .pointTree {
      width: 227px;
      height: 1px;
      flex: 1 0 1px;
      overflow-y: auto;
      overflow-x: auto;
      padding: var(--middle-space) 0;
      /deep/ .el-icon-ziji {
        background: url("./img/ziji.png") no-repeat;
        width: 17px;
      }

      /deep/ .el-icon-ziji:before {
        content: "替";
        font-size: 13px;
        visibility: hidden;
      }
      .tree-node {
        margin-right: 5px;
        display: flex;
        justify-content: space-between;
        width: calc(100% - 30px);
      }
      /deep/ .el-tree-node__label {
        padding-left: 0px;
        width: 130px;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 20px;
        i {
          margin-right: 3px;
        }
        span {
          font-size: 14px;
          color: var(--key-color);
        }
      }
    }
  }
  .planApprovalPointsRight {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 238px;
    right: 0;
    border: 1px solid #ebefff;
    background: #fff;
    min-width: 980px;
    display: flex;
    flex-direction: column;
    .header {
      padding: var(--middle-space) var(--big-space);
      border-bottom: 1px solid #ebefff;
      .el-form-item--small.el-form-item {
        margin-bottom: 0px;
      }
    }
    .templateTable {
      padding: 0 var(--big-space);
      margin: var(--middle-space) 0;
      flex: 1 0 1px;
      // /deep/ .el-icon-arrow-right {
      //   background: url("./img/top.png") no-repeat;
      //   transform: rotate(90deg);
      //   width: 17px;
      // }

      // /deep/ .el-icon-arrow-right:before {
      //   content: "替";
      //   font-size: 13px;
      //   visibility: hidden;
      // }
      .edit {
        color: #4777e7;
        margin-right: 19px;
        cursor: pointer;
      }
      .del {
        color: #4777e7;
        cursor: pointer;
      }
      /deep/ .cell {
        display: flex;
      }
    }
    ::v-deep(.el-table__row:not([class*="el-table__row--level-"])) {
      td:nth-of-type(2){
        padding-left: 22px;
      }
    }
  }
  .ruleForm {
    /deep/ .el-textarea__inner {
      height: 87px;
    }
    /deep/ .el-input__inner {
      width: 464px;
    }
  }
  .pointSetExcel {
    .el-dialog__body {
      padding: 20px !important;
    }
    .downStyle {
      height: 32px;
      line-height: 32px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      p {
        color: var(--key-color);
        font-size: 14px;
      }
    }
    .uploadStyle {
      /deep/ .el-upload-dragger {
        background-color: rgba(85, 132, 255, 0.03);
        border: 1px dashed rgba(71, 119, 231, 0.81);
        height: 235px;
        width: 434px;
        .el-icon-upload {
          background: url("./img/upload.png") no-repeat;
          width: 48px;
        }
        .el-icon-upload:before {
          content: "替";
          font-size: 13px;
          visibility: hidden;
        }
      }
    }
    .uploadListStyle {
      .box {
        text-align: center;
        border-radius: 6px;
        background-color: rgba(85, 132, 255, 0.03);
        border: 1px dashed rgba(71, 119, 231, 0.81);
        width: 360px;
        margin: 0 auto;
        padding: 50px 0px;
      }
    }
  }
}
</style>
